var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"MemberProfileWrapper"}},[(_vm.isMobile)?_c('MemberProfileList'):_c('MemberProfile')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }